import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function getAll(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/aplikasi/getall`, body, config);
  return data;
}

export async function updateForm(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.put(`${apiUrl}/aplikasi/update`, body, config);
  return data;
}

export async function getByID(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/aplikasi`, body, config);
  return data;
}

export async function createInit(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/aplikasi/init`, body, config);
  return data;
}

export async function deleteByID(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.delete(`${apiUrl}/aplikasi/${id}`, config);
  return data;
}
